import script from "./SettingsExportComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsExportComponent.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__